export default class CollapsibleShowMore {
  constructor(node) {
    this.element = node;
    this.initialize();
  }

  initialize() {
    this.element.addEventListener("click", (event) => {
      let buttonValue = event.delegateTarget.querySelector("span.js-button-value");
      let icon = event.delegateTarget.querySelector("i.icon");
      if (event.delegateTarget.classList.contains("collapsed")) {
        buttonValue.innerHTML = event.delegateTarget.dataset.translationExpand;
        icon.className = "icon icon-plus";
      } else {
        buttonValue.innerHTML = event.delegateTarget.dataset.translationCollapse;
        icon.className = "icon icon-minus";
      }
    });
  }
}
